var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 60,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("e-MTA Registration")]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("emta-registration", {
            model: {
              value: _vm.emtaInfo,
              callback: function ($$v) {
                _vm.emtaInfo = $$v
              },
              expression: "emtaInfo",
            },
          }),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c("div", { staticStyle: { "align-self": "flex-start" } }),
            _c("div", { staticStyle: { "align-self": "flex-end" } }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    "data-tooltip": "Register",
                    disabled: !_vm.requireFields,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.register()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-account-plus mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Register")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Cancel")]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }